module.exports = __webpack_public_path__ + "img/icon-5.621df22a.png";